
























































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import copy from 'copy-to-clipboard'
import { EmbedBaseURLWithSchema, serializeVuexStore, deserialize } from "@/util/Serialization";
import Timeline from '../../models/Timeline';
import { SchemaVersion } from '@/util/embed_schema'
import SnapshotList from './SnapshotList.vue';
import ProjectServer from '../../models/ProjectServer';
import { mapGetters } from 'vuex'

function randomStr(len : number, arr : string = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ') { 
	var ans = ''; 
	for (var i = len; i > 0; i--) { 
		ans += arr[Math.floor(Math.random() * arr.length)]; 
	} 
	return ans; 
} 

function replaceAll(target : string, search : string | RegExp, replacement : string) {
	return target.replace(new RegExp(search, 'g'), replacement);
};

@Component({
	components: {
		SnapshotList
	},
	computed: {
		...mapGetters([
            'checkTimelineShare'
        ]),
	}
})
export default class ShareLinkModal extends Vue
{
	@Prop(Array) readonly timelineids!: number[];

	showCreate = false;
	loading = false;

	get activeTimeline()
	{
		return this.$store.state.project.activeTimeline as Timeline;
	}

	get canShareTimeline()
	{
		return (this as any).checkTimelineShare(this.activeTimeline.id);
	}

	async refresh()
	{
		this.loading = true;
		this.max_snapshots = (await this.$http.get<{status : string, count : number}>('sharedembed/max')).data.count;
		this.snapshot_count = (await this.$http.get<{status : string, count : number}>('sharedembed/count')).data.count;
		this.loading = false;
	}

	mounted()
	{
		this.showCreate = false;
		this.shareLink = null;
		this.snapshot_name = "";
		this.refresh();
	}

	snapshot_count = 0;
	max_snapshots = 0;
	message_key = 0
	messages : { key : number, variant : string | undefined, text : string }[] = []
	shareLink : string | null = null;
	snapshot_name = "";

	computeSerializedPayload()
	{
		if (this.timelineids)
		{
			return serializeVuexStore(this.timelineids);
		}
		return serializeVuexStore();
	}

	get randomString()
	{
		return randomStr(32);
	}

	get serialized()
	{
		return this.computeSerializedPayload();
	}

	openAlert()
	{
		this.messages.length = 0;
		this.messages.push({ key: this.message_key++, text: 'Copied share link to your clipboard', variant: 'success' });
	}

	getSnapshotURL(snap : { schema_version : string, id: string })
	{
		let schema = parseInt(snap.schema_version);
		return `${EmbedBaseURLWithSchema(schema)}app/e/snapshot_${snap.id}/`
	}

	async generateSnapshot()
	{
		this.loading = true;

		try
		{
			let req = {
				id: "",
				snapshot_name: this.snapshot_name,
				project_name: this.$store.state.project.project.name,
				timeline_name: this.$store.state.project.activeTimeline.name,
				pid: this.$store.state.project.project.id,
				tid: this.$store.state.project.activeTimeline.id,
				schema_version: SchemaVersion().toString(),
				data: this.computeSerializedPayload()
			};

			let data = new FormData();
            data.append("snapshot_name", req.snapshot_name);
			data.append("project_name", req.project_name);
			data.append("timeline_name", req.timeline_name);
			data.append("schema_version", req.schema_version);
			data.append("data", req.data);
			data.append("pid", req.pid);
			data.append("tid", req.tid);
			
			console.log("Sending request...");
			let resp = await this.$http.post<{status : string, message : string, id : string}>("sharedembed", data);
			console.log("Request sent!");
			req.id = resp.data.id;

			this.snapshot_count = (await this.$http.get<{status : string, count : number}>('sharedembed/count')).data.count;
			//this.shareLink = this.getSnapshotURL(req);
			this.showCreate = false;
			await this.refresh();
			this.snapshot_name = "";
			(this.$refs.snapshotList as any).openShareModal(req);
		}
		catch(err)
		{
			this.messages.length = 0;
			this.messages.push({ key: this.message_key++, text: `Failed to create snapshot: ${err.response.data.error}`, variant: 'danger' });
		}

		this.$emit('snapshot-created');

		this.loading = false;
	}

	clickCreateSnapshot()
	{
		this.showCreate = true;
		let regex = /^Snapshot ([0-9]+)$/;
		let tlSnapshotCount = (this.$refs.snapshotList as SnapshotList).snapshots.length;
		let list = (this.$refs.snapshotList as SnapshotList).snapshots.filter((a)=>{
			let res = regex.test(a.snapshot_name);
			return regex.test(a.snapshot_name);
		}).sort((a,b)=>{
			return b.snapshot_name.trim().localeCompare(a.snapshot_name.trim(), undefined, {numeric: true, sensitivity: 'base'});
		});

		if (list.length == 0)
		{
			this.snapshot_name = `Snapshot ${tlSnapshotCount + 1}`;
			return;
		}

		let res = regex.exec(list[0].snapshot_name);
		if (res)
		{
			let assigned = false;
			res.forEach((a, idx)=>{
				if (assigned) return;
				if (idx == 1)
				{
					let num = parseInt(a);
					if (!isNaN(num))
					{
						this.snapshot_name = `Snapshot ${num + 1}`
						assigned = true;
					}
				}
			});
		}
	}

	copyToClipboard(str : string)
	{
		copy(str);
	}
}
